export default "__VITE_ASSET__sJ$rzdqp__"